import dayjs from 'dayjs';
import { RawTransactionListDto } from '@/features/dashboard/rawBankTransactions/types/RawTransactionListDto.ts';
import { Currency } from '@/features/dashboard/paymentConfig/types/Currency.ts';
import { formatPrice } from '@/utils/formatters.ts';
import { pluralize } from '@/utils/pluralize.ts';

/**
 * Wiersz wyciągu bywa bez nadawcy i bez opisu (tak wygląda część starych
 * importów), więc rozpoznanie schodzi do daty — inaczej pytanie brzmiałoby
 * „usunąć przelew „”?”.
 */
export const rawTransactionLabel = (
  transaction: RawTransactionListDto,
): string => {
  const name = transaction.counterpartyName?.trim();
  const description = transaction.description?.trim();
  const named = name || description;
  return named
    ? `„${named}”`
    : `z ${dayjs(transaction.transactionDate).format('DD.MM.YYYY')}`;
};

export const deleteTransactionDescription = (
  transaction: RawTransactionListDto,
): string =>
  `Przelew ${rawTransactionLabel(transaction)} na ${formatPrice(
    transaction.amount.amount,
    transaction.amount.currency ?? Currency.PLN,
  )} zniknie z listy zaimportowanych. Tej operacji nie można cofnąć.`;

export const deleteTransactionsTitle = (count: number): string =>
  `Usunąć ${pluralize(count, 'przelew', 'przelewy', 'przelewów')}?`;
